import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFormat = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 17,
	viewBox: "0 0 20 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3 13.0035V9.00352H5.45946C5.74054 9.00352 5.98649 9.10352 6.1973 9.30352C6.40811 9.50352 6.51351 9.73685 6.51351 10.0035V10.6702C6.51351 10.8702 6.45788 11.0507 6.34662 11.2119C6.23536 11.373 6.08018 11.5035 5.88108 11.6035L6.51351 13.0035H5.45946L4.82703 11.6702H4.05405V13.0035H3ZM7.04054 13.0035L8.09459 9.00352H9.85135L10.9054 13.0035H9.85135L9.60541 12.0035H8.37568L8.09459 13.0035H7.04054ZM11.7838 13.0035L10.7297 9.00352H11.7838L12.3108 11.0035L12.8378 9.00352H13.8919L14.4189 11.0035L14.9459 9.00352H16L14.9459 13.0035H13.8919L13.3649 10.9702L12.8378 13.0035H11.7838ZM8.62162 11.0035H9.32432L9.14865 10.3369H8.7973L8.62162 11.0035ZM4.05405 10.6702H5.45946V10.0035H4.05405V10.6702Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M2.125 16.5879C1.54062 16.5879 1.04036 16.3921 0.624219 16.0004C0.208073 15.6087 0 15.1379 0 14.5879V2.58789C0 2.03789 0.208073 1.56706 0.624219 1.17539C1.04036 0.783724 1.54062 0.587891 2.125 0.587891H13.625L20 6.58789V14.5879C20 15.1379 19.7919 15.6087 19.3758 16.0004C18.9596 16.3921 18.4594 16.5879 17.875 16.5879H2.125ZM12.8378 7.00351V2.08789H1.5V15.0879L18.5 15.0278V7.00351H12.8378Z",
		fill: "currentColor"
	})]
});
export default SvgFormat;
